import React from 'react';

const Feedback = () => {
  return (
    <div className="min-h-[calc(100vh-96px)] flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-3xl font-bold text-green-900 dark:text-white mb-4">THIS FEEDBACK PAGE IS WORK IN PROGRESS</h1>
      <p className="text-gray-700 dark:text-gray-300">Thank you for visiting</p>
    </div>
  );
};

export default Feedback;